<template>
	<div v-on="$listeners" class="c-card-s-item" :class="{ 'c-card-s-item--border': border }">
		<div class="c-card-s-main">
			<div :class="['c-card-s-title', moduleType === 'news' && 'row-3']">{{ innerItem.subject }}</div>
			<div v-if="innerItem.date" class="c-card-s-date" :class="{ 'c-card-s-date--margin': !getCoverPicture }">
				{{ innerItem.date }}
			</div>
		</div>
		<van-image v-if="getCoverPicture" :src="getCoverPicture" fit="cover" class="c-card-s-cover" />
	</div>
</template>

<script>
import { Image } from 'vant';
import { formatIrYear } from '@/utils/api';
import { mapGetters } from 'vuex';

const MODULE_DEFAULT_COVERS = {
	'news': 'https://image.comein.cn/web/irm/irstore/news_default.png',
	'custom': 'https://image.comein.cn/web/irm/irstore/custom_default.png'
};

export default {
	components: {
		'van-image': Image
	},
	props: {
		item: {
			type: Object,
			default: () => {
				return {};
			}
		},
		formatter: {
			type: Function,
			default: null
		},
		border: {
			type: Boolean,
			default: true
		},
		isShowCoverPicture: {
			type: Boolean,
			default: true
		},
		moduleType: {
			type: String,
			default: ''
		},
		isNews: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			innerItem: {}
		};
	},
	computed: {
		...mapGetters(['getIrBaseInfo']),
		getCoverPicture() {
			if (this.innerItem.imageUrl) return this.innerItem.imageUrl;
			// 投关活动 不展示默认封面
			if (!this.isShowCoverPicture) return '';

			let defaultCover = '';
			const { coverPicture, coverPictureSwitch } = this.getIrBaseInfo;
			if (coverPictureSwitch) {
				defaultCover = coverPicture || MODULE_DEFAULT_COVERS[this.moduleType] || '';
			} else {
				defaultCover = MODULE_DEFAULT_COVERS[this.moduleType] || '';
			}
			return defaultCover;
		}
	},
	methods: {},
	watch: {
		item: {
			handler(val) {
				let updateVal = {};
				if (this.formatter) {
					updateVal = this.formatter();
				} else {
					updateVal = { ...val };
					updateVal.date = formatIrYear(val.date);
				}
				this.innerItem = updateVal;
			},
			immediate: true,
			deep: true
		}
	}
};
</script>

<style lang="less" scoped>
@import '../../../style/mixins';

.c-card-s-item {
	padding-bottom: 0.14rem;
	display: flex;

	&--border {
		.thinner-border-bottom(#e8eaef);
	}
	& + .c-card-s-item {
		margin-top: 0.14rem;
	}
	.c-card-s-main {
		flex: 1;
		width: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.c-card-s-title {
			color: #333;
			/* 15/H5-medium */
			font-family: 'PingFang SC';
			font-size: 0.15rem;
			font-style: normal;
			font-weight: 500;
			line-height: 140%; /* 21px */
			.text-overflow-multi-row(2);
		}
		.row-3 {
			.text-overflow-multi-row(3);
		}
		.c-card-s-date {
			color: #989898;
			/* 11/B2-regular */
			font-family: 'PingFang SC';
			font-size: 0.11rem;
			font-style: normal;
			font-weight: 400;
			line-height: 140%; /* 15.4px */

			&--margin {
				margin-top: 0.08rem;
			}
		}
	}
	.c-card-s-cover {
		flex: none;
		margin-left: 0.08rem;
		width: 1.08rem;
		height: 0.81rem;
		border-radius: 0.02rem;
		overflow: hidden;
	}
}
</style>
